module.exports = __webpack_public_path__ + "static/img/bg54.f0831b35.png";